import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import i18n from '@/i18n'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const labels: Record<string, { now: string; minute: string; hour: string; day: string; month: string; year: string }> = {
  tr: { now: 'şimdi', minute: 'dakika önce', hour: 'saat önce', day: 'gün önce', month: 'ay önce', year: 'yıl önce' },
  en: { now: 'just now', minute: 'min ago', hour: 'hr ago', day: 'days ago', month: 'mo ago', year: 'yr ago' }
}

export function formatDistanceToNow(date: string | Date): string {
  const lang = i18n.language?.startsWith('tr') ? 'tr' : 'en'
  const l = labels[lang]
  const now = new Date()
  const then = new Date(date)
  const seconds = Math.floor((now.getTime() - then.getTime()) / 1000)

  if (seconds < 60) return l.now
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} ${l.minute}`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} ${l.hour}`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days} ${l.day}`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months} ${l.month}`
  return `${Math.floor(months / 12)} ${l.year}`
}

export function formatDate(date: string | Date): string {
  const lang = i18n.language?.startsWith('tr') ? 'tr' : 'en'
  const locale = lang === 'tr' ? 'tr-TR' : 'en-US'
  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

const anonymousPalette = [
  '#ff6f61', '#ec4899', '#8b5cf6', '#6366f1',
  '#06b6d4', '#10b981', '#f59e0b', '#ef4444',
]

function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export function generateAnonymousAvatar(seed: string) {
  const hash = hashString(seed)
  const color = anonymousPalette[hash % anonymousPalette.length]
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><rect width="40" height="40" rx="20" fill="${color}"/></svg>`
  return {
    src: `data:image/svg+xml;base64,${btoa(svg)}`,
    fallback: '?',
    color
  }
}
